import React from "react";
import { withSwal } from "react-sweetalert2";

interface IConfirmAlert {
  text: string;
  message_success?: string;
  cb: (e?: any) => void;
  confirmButtonText?: string;
  confirmButtonColor?: string;
  successTitle?: string;
  className?: string | false;
  error?: boolean;
  error_message?: string;
  errorTitle?: string
}

const ConfirmAlert: React.FC<IConfirmAlert> = withSwal((props: any) => {
  const {
    swal,
    children,
    text,
    cb,
    message_success,
    confirmButtonText,
    confirmButtonColor,
    successTitle,
    className,
    error,
    error_message,
    errorTitle
  } = props;

  return (
    <div
      className={
        className === false ? "" : className ? className : "action-icon"
      }
      id="sa-warning"
      onClick={(e) =>
        swal
          .fire({
            title: "Você tem certeza?",
            text: text,
            icon: "warning",
            showCancelButton: true,
            cancelButtonColor: "#236BB0",
            confirmButtonColor: confirmButtonColor ? confirmButtonColor : "#f34e4e",
            confirmButtonText: confirmButtonText
              ? confirmButtonText
              : "Excluir",
            cancelButtonText: "Cancelar",
          })
          .then(async function (result: { value: any }) {
            try {
              if (result.value) {
                await cb(e);
                if (error) {
                  swal.fire(
                    errorTitle ? errorTitle : "Houve um erro ao deletar",
                    error_message
                      ? error_message
                      : "Por favor, revise os campos e tente novamente. Se o problema persistir, entre em contato com o suporte.",
                    "error"
                  );
                } else {
                  swal.fire(
                    successTitle ? successTitle : "Deletado",
                    message_success
                      ? message_success
                      : "Função deletada com sucesso.",
                    "success"
                  );
                }
              }
            } catch (error: any) {
              if (error?.response?.status === 409) {
                swal.fire(
                  "Conflito",
                  error.response.data.error || "Conflito detectado. Se o problema persistir, entre em contato com o suporte.",
                  "error"
                );
              } else {
                // Erros 4xx trazem o motivo para o usuário (ex.: regra de negócio)
                const status = error?.response?.status;
                const mensagemApi =
                  status >= 400 && status < 500
                    ? error.response.data?.error
                    : undefined;

                swal.fire(
                  errorTitle ? errorTitle : "Erro ao processar",
                  error_message ||
                    (typeof mensagemApi === "string" && mensagemApi) ||
                    "Por favor, tente novamente. Se o problema persistir, entre em contato com o suporte.",
                  "error"
                );
              }
            }
          })
      }
    >
      {children}
    </div>
  );
});

export default ConfirmAlert;
